import React from 'react';
import { useNavigate } from 'react-router-dom';

import MetaTag, { buildMetaTags } from './MetaTag';

/** 2026.09.05 형식 — 언어와 무관하게 동일하게 보이도록 toLocaleDateString을 쓰지 않는다 */
export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}.${mm}.${dd}`;
};

const ArticleCard = ({ article }) => {
  const navigate = useNavigate();

  const { slug, title, seoDescription, coverImageUrl, publishedAt } = article;

  const goToDetail = () => navigate(`/article/${slug}`);
  const metaTags = buildMetaTags(article, formatDate(publishedAt));

  return (
    <article
      role='button'
      tabIndex={0}
      onClick={goToDetail}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToDetail();
        }
      }}
      className='
        group flex w-full cursor-pointer flex-col overflow-hidden
        rounded-[30px] bg-grayscale-gray00 text-left
        ring-[1px] ring-grayscale-gray02
        transition-[box-shadow,background-color,transform] duration-200 ease-out
        motion-reduce:transition-none
        hover:-translate-y-0.5 hover:ring-[6px] hover:ring-surface-green40
        active:translate-y-0 active:bg-green-light01 active:ring-[6px]
        focus:outline-none focus-visible:ring-[6px] focus-visible:ring-surface-green40
      '
    >
      <div className='h-[240px] w-full shrink-0 overflow-hidden bg-grayscale-gray01'>
        {coverImageUrl ? (
          <img
            src={coverImageUrl}
            alt={title}
            loading='lazy'
            className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]'
          />
        ) : (
          <div className='flex h-full w-full items-center justify-center typo-b13 text-text-placeholder'>
            Koready
          </div>
        )}
      </div>

      <div className='flex w-full flex-1 flex-col p-4'>
        <div className='flex flex-1 flex-col gap-1 pb-2 tabletH:gap-1.5 tabletH:pb-4'>
          <h3 className='typo-title3 tabletV:typo-title2 text-grayscale-gray09 line-clamp-2'>
            {title}
          </h3>

          {seoDescription && (
            <p className='typo-krCaption tabletV:typo-b13Strong text-text-secondary line-clamp-2'>
              {seoDescription}
            </p>
          )}
        </div>

        {metaTags.length > 0 && (
          <div className='mt-auto flex flex-wrap items-center gap-1.5'>
            {metaTags.map((tag, index) => (
              <MetaTag key={`${tag}-${index}`}>{tag}</MetaTag>
            ))}
          </div>
        )}
      </div>
    </article>
  );
};

export default ArticleCard;
